// Firebase init (Checkpoint 5.01 — the product spine, Phase 1a). Single place the app instance and
// the Auth service are created, so every other module imports the SAME instances (never a second
// initializeApp). Modular SDK (firebase 12.x): tree-shakeable — we import only initializeApp +
// getAuth here, and the specific auth functions in auth.js, so the bundle carries just app + auth
// (Firestore/Storage/etc. never enter it until a later slice imports them).
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { firebaseConfig } from './firebase-config.js';

export const app = initializeApp(firebaseConfig);

// getAuth wires the default persistence = browserLocalPersistence: a signed-in user is remembered
// across visits/reloads (they land straight in the game, no re-login — Checkpoint 5.01 Lane D). No
// setPersistence call is needed; local is the web default.
export const auth = getAuth(app);
